import Alert from '@mui/material/Alert';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Link from '@mui/material/Link';
import TextField from '@mui/material/TextField';
import { useState } from 'react';
import { useNavigate } from '@tanstack/react-location';
import { apiRawFetch } from '../client';

const LoginForm = () => {
    const navigate = useNavigate();
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setError('');
        setIsLoading(true);

        try {
            const response = await apiRawFetch('api/auth/login', 'POST', {
                username,
                password,
            });

            if (response.ok) {
                const data = await response.json();
                localStorage.setItem('token', data.token);
                // eslint-disable-next-line no-restricted-globals
                location.reload();
            } else {
                setError('Invalid username or password');
            }
        } catch (err) {
            setError(`Login failed. Please try again. ${err}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Box display="flex" flexDirection="column" alignItems="center" mt={14}>
            <Box
                component="form"
                onSubmit={handleSubmit}
                display="flex"
                flexDirection="column"
                gap={2}
                sx={{ width: 300 }}
            >
                <TextField
                    label="Username"
                    type="text"
                    value={username}
                    onChange={e => setUsername(e.target.value)}
                    required
                    disabled={isLoading}
                    fullWidth
                />
                <TextField
                    label="Password"
                    type="password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    required
                    disabled={isLoading}
                    fullWidth
                />
                {error && (
                    <Alert severity="error" sx={{ mt: 1 }}>
                        {error}
                    </Alert>
                )}
                <Button
                    type="submit"
                    variant="contained"
                    disabled={isLoading}
                    sx={{ mt: 2 }}
                >
                    {isLoading ? 'Authenticating...' : 'Login'}
                </Button>
                <Box sx={{ mt: 2, textAlign: 'center' }}>
                    <Link
                        component="button"
                        type="button"
                        variant="body2"
                        onClick={() => navigate({ to: '/forgot-password' })}
                        sx={{ cursor: 'pointer' }}
                    >
                        Forgot Password?
                    </Link>
                </Box>
            </Box>
        </Box>
    );
};

export default LoginForm;
